﻿import 'jquery';
// Make jQuery globally available
(window as any).jQuery = $;
(window as any).$ = $;
import { OrganizationListWidget } from './organizationList';
import { OrganizationEditWidget } from './organizationEdit';


declare global {
    interface Window {
        OrganizationEditWidget: typeof OrganizationEditWidget;
        OrganizationListWidget: typeof OrganizationListWidget;
    }
}

window.OrganizationListWidget = OrganizationListWidget;
window.OrganizationEditWidget = OrganizationEditWidget;

$(function () {
    console.log("main initialized.");
    $(".organization-edit").each(function (index, element) {
        let usersListWidget = new OrganizationEditWidget(element);
        usersListWidget.init();
    });
    $(".organization-list").each(function (index, element) {
        let userEditWidget = new OrganizationListWidget(element);
        userEditWidget.init();
    });         
});
